var _path, _polyline, _line, _line2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg03Design(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "designTitle"
  }, "Design") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "designTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 4 3.5 L 16 3.5 L 20 7.5 L 20 20.5 L 4 20.5 Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "16,3.5 16,7.5 20,7.5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 11,
    x2: 16,
    y2: 11
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 14.5,
    x2: 13,
    y2: 14.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.25,
    cy: 16.5,
    r: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03Design);
export default __webpack_public_path__ + "static/media/03-design.768e269c131094054973536f58576f0b.svg";
export { ForwardRef as ReactComponent };